import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ThemeProvider,
  createTheme,
  AppBar,
  Grid,
  Typography,
} from "@mui/material";
import { employeeShiftSettingApis } from "../../../Data/axios";
import StatusAlert from "../../../StatusAlertList/StatusAlert";

const EmployeeShifts = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [isEdit, setIsEdit] = useState(false);
  const [shiftId, setShiftId] = useState(null);
  const [shiftData, setShiftData] = useState({
    shiftType: "1",
    shiftName: "",
    shiftShortCode: "",
    colorCode: "#000000",
    shiftStartTime: "",
    shiftEndTime: "",
    autoClockOutTime: "",
    halfDayMarkTime: "",
    earlyClockIn: "",
    lateMarkAfter: "",
    maxCheckIn: "",
    officeOpensOn: [],
  });
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const daysOfWeek = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
  ];

  const fetchShifts = async () => {
    try {
      const response = await employeeShiftSettingApis.getAll();
      console.log(response.data, "response got");
      setShifts(response.data);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, []);

  const handleCheckBoxChange = (day) => {
    setShiftData((prevData) => {
      const officeOpensOn = [...prevData.officeOpensOn];
      if (officeOpensOn.includes(day)) {
        return {
          ...prevData,
          officeOpensOn: officeOpensOn.filter((d) => d !== day),
        };
      } else {
        return {
          ...prevData,
          officeOpensOn: [...officeOpensOn, day],
        };
      }
    });
  };

  const item = {
    shift_type: shiftData.shiftType,
    shift_name: shiftData.shiftName,
    shift_short_code: shiftData.shiftShortCode,
    shift_color_code: shiftData.colorCode,
    shift_start_time: shiftData.shiftStartTime,
    shift_end_time: shiftData.shiftEndTime,
    auto_clock_out: shiftData.autoClockOutTime,
    early_clock_in: shiftData.earlyClockIn,
    late_mark_time: shiftData.lateMarkAfter,
    max_clock_in_per_day: shiftData.maxCheckIn,
    ofice_start_on: shiftData.shiftStartTime,
    // total_work_hour: shiftData.halfDayMarkTime,
    half_day_mark_hrs: shiftData.halfDayMarkTime,
  };
  const handleSaveShift = async () => {
    try {
      if (isEdit) {
        const formData = new FormData();
        for (const key in item) {
          if (item[key] !== undefined && item[key] !== null) {
            formData.append(key, item[key]);
          }
        }

        await employeeShiftSettingApis.updateById(shiftId, formData);

        showAlert("Added successfully", "success");
      } else {
        console.log(item, "item got");
        const formData = new FormData();
        for (const key in item) {
          if (item[key] !== undefined && item[key] !== null) {
            formData.append(key, item[key]);
          }
        }

        await employeeShiftSettingApis.add(formData);

        showAlert("Added successfully", "success");
      }
      fetchShifts();
      setOpenDialog(false);
      resetShiftData();
    } catch (error) {
      console.error("Error saving shift:", error);
    }
  };

  const handleEditShift = (shift) => {
    setShiftData(shift);
    setShiftId(shift.id);
    setIsEdit(true);
    setOpenDialog(true);
  };

  const handleDeleteShift = async (id) => {
    try {
      await employeeShiftSettingApis.deleteById(id);
      fetchShifts();
    } catch (error) {
      console.error("Error deleting shift:", error);
    }
  };

  const resetShiftData = () => {
    setShiftData({
      shiftType: "Strict Timings",
      shiftName: "",
      shiftShortCode: "",
      colorCode: "#000000",
      shiftStartTime: "",
      shiftEndTime: "",
      autoClockOutTime: "",
      halfDayMarkTime: "",
      earlyClockIn: "",
      lateMarkAfter: "",
      maxCheckIn: "",
      officeOpensOn: [],
    });
    setShiftId(null);
    setIsEdit(false);
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#007BFF",
      },
    },
    typography: {
      fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"],
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <div style={{ padding: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            resetShiftData();
            setOpenDialog(true);
          }}
          sx={{ "&:hover": { backgroundColor: "orange" } }}
        >
          Add New Shift
        </Button>

        <TableContainer component={Paper} style={{ marginTop: "20px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Others</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shifts.map((shift, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <span
                      style={{
                        padding: "5px 10px",
                        color: shift.colorCode,
                        borderRadius: "5px",
                      }}
                    >
                      {shift.shift_name}
                    </span>
                  </TableCell>
                  <TableCell>
                    Start Time: {shift.shift_start_time}
                    <br />
                    Half Day: {shift.half_day_mark_time}
                    <br />
                    End Time: {shift.shift_end_time}
                  </TableCell>
                  <TableCell>
                    Late mark after (minutes): {shift.late_mark_time}
                    <br />
                    Maximum check-in allowed in a day:{" "}
                    {shift.max_clock_in_per_day}
                    <br />
                    {/* Office opens on: {shift.officeOpensOn.join(", ")} */}
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      variant="outlined"
                      sx={{ marginRight: "5px" }}
                      onClick={() => handleEditShift(shift)}
                    >
                      Edit
                    </Button>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => handleDeleteShift(shift.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          fullWidth
          maxWidth="md"
        >
          <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
            <DialogTitle sx={{ color: "white" }}>
              {isEdit ? "Edit Shift" : "Add New Shift"}
            </DialogTitle>
          </AppBar>

          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              {/* Shift Type Radio Group - Full Width */}
              <Grid item xs={12}>
                <RadioGroup
                  row
                  value={shiftData.shiftType}
                  onChange={(e) =>
                    setShiftData({ ...shiftData, shiftType: e.target.value })
                  }
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Strict Timings"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="Flexible Timings"
                  />
                </RadioGroup>
              </Grid>

              {/* Shift Name and Short Code */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Shift Name"
                  value={shiftData.shiftName}
                  onChange={(e) =>
                    setShiftData({ ...shiftData, shiftName: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Shift Short Code"
                  value={shiftData.shiftShortCode}
                  onChange={(e) =>
                    setShiftData({
                      ...shiftData,
                      shiftShortCode: e.target.value,
                    })
                  }
                />
              </Grid>

              {/* Color Code, Start Time and End Time in one row */}
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Color Code"
                  type="color"
                  value={shiftData.colorCode}
                  onChange={(e) =>
                    setShiftData({ ...shiftData, colorCode: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Shift Start Time"
                  type="time"
                  inputProps={{
                    style: { width: "100%" },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={shiftData.shiftStartTime}
                  onChange={(e) =>
                    setShiftData({
                      ...shiftData,
                      shiftStartTime: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Shift End Time"
                  type="time"
                  inputProps={{
                    style: { width: "100%" },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={shiftData.shiftEndTime}
                  onChange={(e) =>
                    setShiftData({ ...shiftData, shiftEndTime: e.target.value })
                  }
                />
              </Grid>

              {/* Auto Clock Out, Half-day Mark Time, and Early Clock In in one row */}
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Auto Clock Out Time (In Hours)"
                  type="number"
                  value={shiftData.autoClockOutTime}
                  onChange={(e) =>
                    setShiftData({
                      ...shiftData,
                      autoClockOutTime: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Half-day Mark Time"
                  inputProps={{
                    style: { width: "100%" },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type="time"
                  value={shiftData.halfDayMarkTime}
                  onChange={(e) =>
                    setShiftData({
                      ...shiftData,
                      halfDayMarkTime: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Early Clock In (minutes)"
                  type="number"
                  value={shiftData.earlyClockIn}
                  onChange={(e) =>
                    setShiftData({ ...shiftData, earlyClockIn: e.target.value })
                  }
                />
              </Grid>

              {/* Late mark after and Maximum check-in */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Late mark after (minutes)"
                  type="number"
                  value={shiftData.lateMarkAfter}
                  onChange={(e) =>
                    setShiftData({
                      ...shiftData,
                      lateMarkAfter: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Maximum check-in allowed in a day"
                  type="number"
                  value={shiftData.maxCheckIn}
                  onChange={(e) =>
                    setShiftData({ ...shiftData, maxCheckIn: e.target.value })
                  }
                />
              </Grid>

              {/* Office Opens On - Full Width */}
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Office opens on:
                </Typography>
                <Grid container spacing={1}>
                  {daysOfWeek.map((day) => (
                    <Grid item key={day.value}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            // checked={shiftData.officeOpensOn.includes(
                            //   day.value
                            // )}
                            onChange={() => handleCheckBoxChange(day.value)}
                          />
                        }
                        label={day.label}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={() => setOpenDialog(false)}
              color="secondary"
              sx={{ color: "grey" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSaveShift}
              color="primary"
              variant="contained"
              sx={{ "&:hover": { backgroundColor: "orange" } }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default EmployeeShifts;
